export interface BillingModel {
  amount: number;
  creditValue: number;
  vatCharged?: number;
  vatRate?: number;
  vatNumber?: string;
  totalAmount?: number;
  firstName?: string;
  lastName?: string;
  companyName?: string;
  email?: string;
  countryCode?: string;
  zip?: string;
  city?: string;
  state?: string;
  street?: string;
  houseNumber?: string;
  issuedType?: BillingIssuedType;
}

// String values: Public.Api sends enum member NAMES (global JsonStringEnumConverter), so an
// inbound numeric comparison would never match. Safe for the outbound direction too — this
// value is sent on billing/checkout, and JsonStringEnumConverter deserializes member names
// as well as numbers. Must mirror the C# member names.
export enum BillingIssuedType {
  Personal = 'Personal',
  Company = 'Company',
}

export interface ViesCheckVatResponse {
  countryCode: string;
  vatNumber: string;
  requestDate: string;
  name: string;
  address: string;
  isValid: boolean;
}

export interface UploadFinalizeCommand {
  amount: number;
  orderId: string;
  billing: BillingModel;
}

export interface IpDetails {
  city: string;
  continentCode: string;
  continentName: string;
  countryCode: string;
  countryName: string;
  ip: string;
  isEu: boolean;
}